import { useEffect, useState } from 'react';

//import { ChamadoService } from 'services/main/endpoints/ChamadoService';
import { RegistrationService } from 'services/main/endpoints/RegistrationService';

import { SignatureInput } from 'components/Form/subcomponents/SignatureInput';

import { ReactComponent as CloseIcon } from 'assets/icons/close-gray.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/yellow-warning.svg';
import { ReactComponent as BlueWarningIcon } from 'assets/icons/blue-warning.svg';
import { useCookies } from 'react-cookie';
import {
  AproveButton,
  CloseButton,
  Content,
  Header,
  HeaderTitle,
  Modal,
  SignatureWarning,
  StyledFormGroup,
  StyledFormRadio,
  TransparentBg,
  Warning,
} from './styled';
import * as Sentry from '@sentry/react';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { RadioButton } from 'components/Form/subcomponents/ButtonRadio';
import { Textarea } from 'components/Form/subcomponents/Textarea';
import { GrayLoading } from 'components/Loading/GrayLoading';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { ChamadoService } from 'services/main/endpoints/ChamadoService';
import { createErrorToast, createGenericErrorToast, createSuccessToast } from 'utils/createToast';
export const AproveModal = ({ setToastList, data, setAproveModalIsopen, updateTable }) => {
  const cookie = useCookies()[0];
  const [signature, setSignature] = useState('');
  const [loading, setLoading] = useState(true);
  const {
    control,
    handleSubmit,
    //formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      decision: '',
      description: '',
      rate: '',
      avaliation: '',
    },
  });
  const getUserSignature = async () => {
    setLoading(true);
    const EmpresaId = cookie.companies?.id;
    const userId = cookie.chamadosAccess.userId;
    try {
      const response = await RegistrationService.getChamadoUserInfo({ EmpresaId, id: userId });
      return response?.data?.assinaturaPath;
    } catch (err) {
      console.error(err);
      Sentry.captureException(err);
      createGenericErrorToast(setToastList);
    } finally {
      setLoading(false);
    }
  };
  const aproveOcurrence = async values => {
    try {
      Sentry.captureMessage('Salvar Aprovação', {
        tags: { Empresa: cookie.companies?.id },
      });
      const EmpresaId = cookie.companies?.id;
      if (values.decision === 'rejeitado' && values.description.length < 1) {
        createErrorToast(setToastList, 'Preencha a descrição.');
        return;
      }
      const formattedData = {
        anomaliaId: data?.anomaliaGid,
        statusAprovacaoId: values.decision === 'aprovado' ? 2 : 3,
        descricaoAprovacao: values?.description,
        statusAvaliacaoId: values?.rate === '' ? null : values?.rate,
        temAssinatura: false,
        assinaturaPath: signature,
        usuarioAssinaturaId: cookie.chamadosAccess.userId,
        descricaoAvaliacao: values?.avaliation,
        //usuarioAssinaturaNaoCadastrado: '',
      };
      const response = await ChamadoService.aproveOcurrence({
        empresaId: EmpresaId,
        unidadeId: data?.unidade,
        data: formattedData,
      });
      if (response.data.message === 'Ocorrência aprovada com sucesso') {
        createSuccessToast(setToastList, 'Aprovação realizada.');
        setAproveModalIsopen(false);
        updateTable();
      }
    } catch (err) {
      console.error(err);
      createGenericErrorToast(setToastList);
      Sentry.captureException(err);
    }
  };
  useEffect(() => {
    const getSignature = async () => {
      setSignature(await getUserSignature());
    };
    getSignature();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TransparentBg>
      <Modal height={''}>
        {loading ? (
          <>
            {' '}
            <GrayLoading />
          </>
        ) : (
          <>
            <Header>
              {signature ? <HeaderTitle>Aprovar</HeaderTitle> : <HeaderTitle>Adicionar Assinatura</HeaderTitle>}
              <CloseButton onClick={() => setAproveModalIsopen(false)}>
                <CloseIcon />
              </CloseButton>
            </Header>
            {signature ? (
              <FormProvider {...{ control, handleSubmit, setValue, watch }}>
                <Content>
                  <FieldRow marginTop={'24px'} />
                  <StyledFormGroup label={'Você aprova o serviço?'}>
                    <FieldRow marginTop={'18px'} />
                    <StyledFormRadio>
                      <Controller
                        name="decision"
                        control={control}
                        render={props => (
                          <>
                            <RadioButton
                              text={'Aprovado'}
                              icon={'IconeCheck'}
                              onClick={() => props.onChange('aprovado')}
                              isActive={props.value === 'aprovado'}
                            />
                            <RadioButton
                              text={'Rejeitado'}
                              icon={'IconeX'}
                              onClick={() => props.onChange('rejeitado')}
                              isActive={props.value === 'rejeitado'}
                            />
                          </>
                        )}
                      />
                    </StyledFormRadio>
                  </StyledFormGroup>
                  <FieldRow marginTop={'24px'} />
                  {watch('decision') !== '' && (
                    <>
                      {watch('decision') === 'rejeitado' && (
                        <StyledFormGroup label="Descrição" isRequired>
                          <FieldRow marginTop="18px" />
                          <Controller
                            name="description"
                            defaultValue=""
                            control={control}
                            render={props => (
                              <Textarea
                                {...props}
                                size="custom"
                                placeholder="Escreva aqui o que ocorreu"
                                width="100%"
                                customStyle={{
                                  padding: '12px',
                                  resize: 'none',
                                  overflow: 'scroll',
                                  height: '120px',
                                }}
                              />
                            )}
                          />
                        </StyledFormGroup>
                      )}
                      {watch('decision') === 'aprovado' && (
                        <>
                          <StyledFormGroup label="Qual a sua avaliação do serviço?">
                            <FieldRow marginTop="18px" />
                            <StyledFormRadio>
                              <Controller
                                name="rate"
                                control={control}
                                render={props => (
                                  <>
                                    <RadioButton
                                      text={'Ótimo'}
                                      icon={'SmileIcon'}
                                      onClick={() => props.onChange(3)}
                                      isActive={props.value === 3}
                                    />
                                    <RadioButton
                                      text={'Bom'}
                                      icon={'MehIcon'}
                                      onClick={() => props.onChange(2)}
                                      isActive={props.value === 2}
                                    />
                                    <RadioButton
                                      text={'Regular'}
                                      icon={'FrownIcon'}
                                      onClick={() => props.onChange(1)}
                                      isActive={props.value === 1}
                                    />
                                    <RadioButton
                                      text={'Ruim'}
                                      icon={'FrownIcon'}
                                      onClick={() => props.onChange(5)}
                                      isActive={props.value === 5}
                                    />
                                    <RadioButton
                                      text={'Não avaliar'}
                                      onClick={() => props.onChange(4)}
                                      isActive={props.value === 4}
                                    />
                                  </>
                                )}
                              />
                            </StyledFormRadio>
                          </StyledFormGroup>
                          <FieldRow marginTop="24px" />
                          <StyledFormGroup label="Explique o motivo da sua avaliação" isRequired>
                            <FieldRow marginTop="18px" />
                            <Controller
                              name="avaliation"
                              defaultValue=""
                              control={control}
                              render={props => (
                                <Textarea
                                  {...props}
                                  size="custom"
                                  placeholder="Escreva um comentário"
                                  width="100%"
                                  customStyle={{
                                    padding: '12px',
                                    resize: 'none',
                                    overflow: 'scroll',
                                    height: '120px',
                                  }}
                                />
                              )}
                            />
                          </StyledFormGroup>
                        </>
                      )}
                      <FieldRow marginTop="24px" />
                      <Warning>
                        <BlueWarningIcon /> Sua assinatura cadastrada será vinculada automaticamente.
                      </Warning>
                      <FieldRow marginTop="24px" />
                      <AproveButton onClick={handleSubmit(aproveOcurrence)}>Aprovar</AproveButton>
                      <FieldRow marginTop="24px" />
                    </>
                  )}
                </Content>
              </FormProvider>
            ) : (
              <Content>
                <SignatureWarning>
                  {' '}
                  <WarningIcon />
                  Cadastre uma assinatura para aprovar chamados.
                </SignatureWarning>
                <SignatureInput setToastList={setToastList} setSignature={setSignature} />
              </Content>
            )}
          </>
        )}
      </Modal>
    </TransparentBg>
  );
};
